import { Category } from 'src/pages/customer-center/data/types/Category';
import { Settings } from 'src/pages/customer-center/data/types/Settings';
import { createController, createControllerEndpoint } from '../utils/api'
import { useGlobalProject } from 'src/utils/globals';
import { Article, ArticleContent } from 'src/pages/customer-center/data/types/Article';
import { PagedResults } from 'src/pages/customer-center/data/types/Paging';
import { KBUser } from 'src/pages/customer-center/data/types/Users';

const project = useGlobalProject() || { UniqueCode: '' };

export default createController('/api/v1/customer-center/' + project.UniqueCode, {
    getAllCategories: createControllerEndpoint<Array<Category>>('GET', '/categories'),
    saveCategories: createControllerEndpoint<Array<Category>>('PUT', '/categories'),
    saveCategoriesFeaturedOrder: createControllerEndpoint<void>('PUT', '/categories/featured-order'),
    saveCategoriesFeaturedIcon: createControllerEndpoint<void>('PUT', '/categories/{id}/icon'),
    toggleCategoryFeaturedState: createControllerEndpoint<void>('PUT', '/categories/{id}/featured'),

    getSettings: createControllerEndpoint<Settings>('GET', '/settings'),
    saveSettings: createControllerEndpoint<Settings>('PUT', '/settings'),
    saveBuiltInDomain: createControllerEndpoint<{ result: boolean }>('PUT', '/settings/domain/builtin'),
    saveCustomDomain: createControllerEndpoint<{ result: boolean }>('POST', '/settings/domain/custom'),

    getUsers: createControllerEndpoint<PagedResults<KBUser>>('GET', '/users'),
    createUser: createControllerEndpoint<KBUser>('POST', '/users/create'),
    inviteUser: createControllerEndpoint<KBUser>('POST', '/users/invite'),
    removeUser: createControllerEndpoint<void>('DELETE', '/users/remove/{id}'),

    getAllArticles: createControllerEndpoint<PagedResults<Article>>('GET', '/articles'),
    searchArticles: createControllerEndpoint<Array<Article>>('POST', '/articles'),
    createArticle: createControllerEndpoint<{ id: number }>('POST', '/articles/new'),
    saveArticleContent: createControllerEndpoint<{ id: number }>('POST', '/articles/{id}/content'),
    deleteArticleById: createControllerEndpoint<void>('DELETE', '/articles/{id}'),
    getArticleById: createControllerEndpoint<Article>('GET', '/articles/{id}'),
    changeArticleContentSlug: createControllerEndpoint<{ result: ArticleChangeSlugResult }>('PUT', '/articles/{id}/content/slug/{contentId}'),
    toggleArticleFeaturedState: createControllerEndpoint<void>('PUT', '/articles/{id}/featured'),
    saveFeaturedArticlesOrder: createControllerEndpoint<void>('PUT', '/articles/reorder/featured'),

    setArticlePrivate: createControllerEndpoint<{ isPrivate: boolean }>('PUT', '/articles/{id}/set-private'),
    setArticlePublic: createControllerEndpoint<{ isPrivate: boolean }>('PUT', '/articles/{id}/set-public'),

    addContent: createControllerEndpoint<ArticleContent>('POST', '/articles/{id}/content/new'),
    deleteContent: createControllerEndpoint<ArticleContent>('DELETE', '/articles/content/{id}'),
    publishContent: createControllerEndpoint<ArticleContent>('POST', '/articles/{id}/content/publish/{articleContentId}'),
    unpublishByLanguage: createControllerEndpoint<void>('POST', '/articles/{id}/content/unpublish/{language}'),

    assignArticleToCategory: createControllerEndpoint<{ newCategoryId?: number }>('PUT', '/articles/{id}/category'),

    reorderArticles: createControllerEndpoint<void>('PUT', '/articles/reorder'),
});

export enum ArticleChangeSlugResult {
    OK = 1,
    OKButDifferentThanOtherContents,
    AlreadyExists,
    WrongFormat
}
